import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';
import { boxShadow } from 'js/config/style';

const Container = animated(styled.div`
  background: white;
  box-shadow: ${boxShadow};
  border-radius: 0.25rem;
`);

export default ({ opacity, ...props }) => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: opacity || 1 }} config={{ delay: 200 }}>
    {animation => <Container style={animation} {...props} />}
  </Spring>
);
